/** Espace sous-traitant : sa propre session, ses sous-routes dans `SubcontractorApp`. */
import { lazy } from 'react';
import type { ExternalRoute } from '../../app/route-types.js';

const SubcontractorApp = lazy(() => import('./SubcontractorApp.js').then((m) => ({ default: m.SubcontractorApp })));

export const subcontractorRoutes: ExternalRoute[] = [
  { path: '/sous-traitant/*', element: <SubcontractorApp /> },
];
